<template>
    <form-group :validator="v" :label="label" :label-for="id"  :description="tip">
        <template slot-scope="{ attrs, listeners }">
            <v-select :id="id"
                :inputId="id"
                :options="options"
                :value="value"
                :reduce="option => option"
                :aria-label="sr"  
                :screenreader="sr"
                @input="onSelected"
                :data-test="slug"
                :state="v.$dirty ? !v.$error : null"
                v-bind="attrs"
                v-on="listeners">
                <template #search="{attributes, events}">
                    <input
                        class="vs__search"
                        :required="!value"
                        v-bind="attributes"
                        v-on="events"
                        :state="v.$dirty ? !v.$error : null"
                        />
                </template>
            </v-select>
        </template>
    </form-group>
</template>

<script>
import _ from "lodash"
import axios from "axios"

export default {
    props: {
        value: [String],
        label: [String],
        tip: [String],
        slug: [String],
        sr: [String],
        v: [Object],
        setId: [String],
        required: [Boolean]
    },
    data() {
        return {
            options: [  ],            
            defaultSelection: ''
        } 
    },
    created() {
        axios.get(`${process.env.VUE_APP_API_BASE_URL}/meta/classifications`)
           .then((values) => {
               this.options = values.data
           })
    },
    computed: {
        id() {
            if (this.setId === null) {
                return _.uniqueId('classificationSelector')
            } else {
                return this.setId
            }
        },
    },
    methods: {
        onSelected(item) {
            this.$emit('input', item)
        },
  }
}
</script>

<style>
.vs__dropdown-menu {
    max-height:200px;
}
.vs__spinner {
    font-size: 1em;
}
fieldset > legend {
    font-weight: 750;
}
</style>